import React, {useState, useEffect, useContext} from 'react';
import { LayoutContext } from '_context/LayoutContext';
//import SimulateMap from 'component/mapModule/SimulateMap';
import OlSimulateMap from 'component/mapModule/OlSimulateMap';
import {MapContext} from '_context/MapContext';

const SIMUL = (props) => {
    const { chgStatus, status } = useContext(LayoutContext);
    const { rp } = useContext(MapContext);
    const [ sMap, setSMap ] = useState(null);

    useEffect(() => {
        if(status==='simul'){
            makeMap()
        }
    }, [status]);

    const makeMap = () => {
        if(!sMap){
            setSMap(<OlSimulateMap/>)
        }
    }

    return (
        <div className="wrapOnenaviSimul"  style={{display:status==='simul'?'block':'none'}}>
            <div className="topWayPoint">
                <span className="start">{rp.start && rp.start.keyword?rp.start.keyword:''}</span>
                <span className="wayPoint" style={{display:rp.wayPoints && rp.wayPoints.length>0?'contents':'none'}}>{rp.wayPoints && rp.wayPoints.length>0?'경유('+rp.wayPoints.length+')':''}</span>
                <span className="dest">{rp.end && rp.end.keyword?rp.end.keyword:''}</span>
            </div>
            {sMap}
            <button className="btnsSch btnClose" onClick={(e) => chgStatus('rp')}>닫기</button>
        </div>
    )
}

export default SIMUL